import { Injectable } from '@angular/core';
import { CanLoad, Route, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanLoad {

  constructor(private authService: AuthService, private router: Router) { }

  canLoad(route: Route): boolean {
    if (this.authService.getCurrentUser())
      return true;
    else {
      this.router.navigate(["account/unauthorized"]);
      return false;
    }
  }
}
